import { useLocation } from "react-router-dom";

export function useQueryUrl() {
  const location = useLocation();
  return new URLSearchParams(location.search);
}
